import { Modal } from "@mui/material";
import { forwardRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  BadgeText,
  CustomButton,
  BadgeContainer,
  BadgeIconContainer,
} from "./styles";
import { useTranslate } from "../../../../hooks/useTranslate";

interface IButton {
  top: number;
  label: string;
  icon: JSX.Element;
  onClick: () => void;
}

interface Props {
  open: boolean;
  close: () => void;
  buttons: IButton[];
  handleFileChange: (e: any) => void;
}

const BatchResgistrationOptionsModal = forwardRef(
  ({ open, close, handleFileChange, buttons }: Props, ref: any) => {
    const { translate } = useTranslate();

    return (
      <Modal open={open}>
        <>
          <CustomButton
            onClick={close}
            color="secondary"
            variant="contained"
            startIcon={<CloseIcon />}
          >
            {translate("global.close")}
          </CustomButton>

          {buttons.map(({ top, icon, label, onClick }, index) => (
            <BadgeContainer top={top} key={index} onClick={onClick}>
              <BadgeText>{label}</BadgeText>

              <input
                type="file"
                ref={ref}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <BadgeIconContainer>{icon}</BadgeIconContainer>
            </BadgeContainer>
          ))}
        </>
      </Modal>
    );
  }
);

export default BatchResgistrationOptionsModal;
